import { z } from "zod";

export const UserSignupSchema = z
  .object({
    email: z
      .string()
      .trim()
      .min(1, "Email is required.")
      .email("Invalid email address."),
    phoneNumber: z
      .string()
      .trim()
      .min(10, "Phone number must be at least 10 digits.")
      .max(15, "Phone number must be at most 15 digits.")
      .optional(),
    password: z
      .string()
      .min(1, "Please enter your password.")
      .min(8, "Your password must have 8 characters or more."),
    password2: z.string().min(1, "Please confirm your password."),
    clerkUserId: z.string().trim().optional(),
  })
  .refine((data) => data.password === data.password2, {
    message: "The two passwords do not match.",
    path: ["password2"],
  });

export type UserSignupForm = z.infer<typeof UserSignupSchema>;

export const UserProfileSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, "First name is required.")
    .max(50, "First name must be 50 characters or less."),
  lastName: z
    .string()
    .trim()
    .min(1, "Last name is required.")
    .max(50, "Last name must be 50 characters or less."),
  email: z
    .string()
    .trim()
    .min(1, "Email is required.")
    .email("Invalid email address."),
  photo: z.string().optional(), // Handling as optional, can be a File object
  phoneNumber: z
    .string()
    .trim()
    .min(10, "Phone number must be at least 10 digits.")
    .max(15, "Phone number must be at most 15 digits.")
    .optional(),
  clerkUserId: z.string().trim().optional(),
});

export type UserProfileForm = z.infer<typeof UserProfileSchema>;

export const UserSigninSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email is required.")
    .email("Invalid email address."),
  password: z
    .string()
    .min(1, "Please enter your password.")
    .min(8, "Your password must have 8 characters or more."),
});

export const codeSchema = z.object({
  code: z
    .array(z.string().min(1, "Each field must have a value"))
    .length(6, "Code must be 6 digits")
    .refine(
      (input) => input.every((digit) => /^\d$/.test(digit)),
      "All fields must be digits",
    ),
});
export type UserSigninForm = z.infer<typeof UserSigninSchema>;

export const UserForgotPasswordSchema = z
  .object({
    email: z
      .string()
      .trim()
      .min(1, "Email is required.")
      .email("Invalid email address."),
    password: z
      .string()
      .min(1, "Please enter your password.")
      .min(8, "Your password must have 8 characters or more."),
    password2: z.string().min(1, "Please confirm your password."),
  })
  .refine((data) => data.password === data.password2, {
    message: "The two passwords do not match.",
    path: ["password2"],
  });

export type UserForgotPasswordForm = z.infer<typeof UserForgotPasswordSchema>;
